export class GetAsiOrgIdRequest {
    ACVID: string|number = 0;
    LOB = 'OL';
}
